// Redesign v3.2 building blocks on the --v3-* tokens (styles/tailwind.css):
// neutral panel and surfaces, hairline borders, colour only for meaning.
// The same classes work in light and dark mode.

// A raised card: the panel colour with a hairline edge, 14px radius.
export const V3_PANEL = "rounded-v3-panel bg-v3-panel shadow-v3-hairline";

// Select triggers and similar fields: a sunken surface with a hairline.
export const V3_FIELD =
  "h-11 rounded-[10px] border-0 bg-v3-surface-2 px-3 text-[14px] font-medium text-v3-text shadow-v3-hairline transition-colors hover:bg-v3-surface-3 focus:ring-2 focus:ring-v3-brand-ring";

// Dropdown menus (SelectContent, popovers).
export const V3_MENU =
  "rounded-xl border-0 bg-v3-panel font-v3 text-v3-text shadow-v3-pop";

// Pill buttons: brand for the main action, surface with a hairline for the
// secondary one. For use on <Button>, overriding its variant colours.
export const V3_BUTTON_PRIMARY =
  "h-11 rounded-full bg-v3-brand px-5 py-0 text-[14px] font-semibold text-v3-on-brand shadow-none transition-opacity hover:bg-v3-brand hover:opacity-90";
export const V3_BUTTON_SECONDARY =
  "h-11 rounded-full border-0 bg-v3-surface-2 px-5 py-0 text-[14px] font-semibold text-v3-text shadow-v3-hairline hover:bg-v3-surface-3 hover:text-v3-text";

// A quiet pill (label or feature tag).
export const V3_CHIP =
  "inline-flex h-7 items-center gap-1.5 whitespace-nowrap rounded-full px-3 text-[12.5px] font-medium text-v3-text-2 shadow-v3-hairline-strong";
